var path = '/components/directives/customfield/password.tpl.html';
var html = "<label for=\"{{name}}\" ng-if=\"field.definition.name\">{{field.definition.name}}\n    <span ng-if=\"field.definition.required\">*</span>\n    <i class=\"fal fa-info-circle\" ng-if=\"field.definition.tooltip\">\n        <span data-tooltip=\"{{::field.definition.tooltip}}\"></span>\n    </i>\n</label>\n<p class=\"help-text\" ng-if=\"field.definition.help\">{{field.definition.help}}</p>\n<input id=\"{{name}}\" type=\"password\" ng-model=\"field.ngModel\" name=\"{{name}}\" class=\"form-control\"/>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/password.tpl.html
// module id = 1998
// module chunks = 1